import { FirebaseData } from "../../General/FirebaseData";

export class CollectionItemRoutineData extends FirebaseData {

  title: string = "";
  active: boolean = true;

  setup(data: any) {
    this.title = typeof data.title === "string" ? data.title : "";
    this.active = typeof data.active === "boolean" ? data.active : true;

    super.setup(data);
  }
}